import { render, staticRenderFns } from "./AssignmentsTab.vue?vue&type=template&id=de1f66c8&scoped=true&"
import script from "./AssignmentsTab.vue?vue&type=script&lang=js&"
export * from "./AssignmentsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1f66c8",
  null
  
)

export default component.exports